const Filter = (props: React.SVGAttributes<SVGSVGElement>) => (
    <svg
        width='16'
        height='15'
        viewBox='0 0 16 15'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            opacity='0.4'
            d='M6.13882 6.81567L0.804996 1.72329C0.152509 1.10034 0.59343 0 1.49554 0H14.5045C15.4066 0 15.8475 1.10034 15.195 1.72329L9.86118 6.81567C9.66354 7.00436 9.55172 7.26571 9.55172 7.53895V12.6092C9.55172 12.8824 9.43991 13.1438 9.24227 13.3325L8.13882 14.386C7.50249 14.9935 6.44828 14.5425 6.44828 13.6627V7.53895C6.44828 7.2657 6.33646 7.00436 6.13882 6.81567Z'
            fill='white'
        />
    </svg>
);

export default Filter;
